import ProductPageContainer from "../../../../Components/Applications/Ecommerce/ProductPage/ProductPageContainer";

const ProductPage = () => {
  return <ProductPageContainer />;
};

export default ProductPage;
